import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}
  setItem(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  getItem(key: string) {
    if (localStorage.getItem(key)) {
      return JSON.parse(localStorage.getItem(key)||'');
    }
    return null;
  }
  clearStorage(){
    localStorage.clear();
  }
  removeItem(key: string) {
    localStorage.removeItem(key)
  }
}
